export interface IFracnhises {
  status: TStatus;
  data: TFranchise[];
}

export type TFranchise = {
  id: number;
  name: string;
  description: string;
  support: string;
  link: string;
  phone: string;
  avatar: string;
  region: string;
  price: string;
  infoInNumbers: IInfoInNumber[];
};

export interface IInfoInNumber {
  name: string;
  key: string;
  value: boolean | number | string;
  forOrder?: number;
}

export enum TStatus {
  Initial = 'init',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}
